import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import { closeSnackbar, getSnacks, initSnacksQueue } from 'ducks/ux'

export const useSnackbar = () => {
  const snacks = useSelector(getSnacks)
  const dispatch = useDispatch()

  const activeSnacks = React.useMemo(
    () => R.pipe(R.values, R.map(R.head), R.filter(Boolean))(snacks),
    [snacks],
  )

  const handleShowSnackbar = React.useCallback(
    ({ message, type, timeout }) => {
      dispatch(initSnacksQueue({ message, type, timeout }))
    },
    [dispatch],
  )

  const handleHideSnackbar = React.useCallback(
    ({ id, type }) => {
      dispatch(closeSnackbar({ id, type }))
    },
    [dispatch],
  )

  return {
    state: { snacks: activeSnacks },
    handlers: {
      handleShowSnackbar,
      handleHideSnackbar,
    },
  }
}
